module.exports = __webpack_public_path__ + "img/1.5cc023d3.png";